import { createContext, useMemo } from "react";
import { useWindowSize } from "usehooks-ts";

export interface ScreenType {
  size: ScreenSize;
}

export type ScreenSize = typeof ScreenSize.DESKTOP | typeof ScreenSize.MOBILE;

export namespace ScreenSize {
  export const DESKTOP = Symbol("DESKTOP");
  export const MOBILE = Symbol("MOBILE");
}

export const ScreenTypeContext = createContext<ScreenType>({
  size: ScreenSize.DESKTOP,
});

function getScreenType(size: { width: number; height: number }): ScreenType {
  if (size.width <= 600) {
    return { size: ScreenSize.MOBILE };
  }
  return { size: ScreenSize.DESKTOP };
}

export const ScreenTypeContextProvider = ({ children }) => {
  const size = useWindowSize();
  const screenType = useMemo(() => getScreenType(size), [size]);

  return (
    <ScreenTypeContext.Provider value={screenType}>
      {children}
    </ScreenTypeContext.Provider>
  );
};
